/**
 * iandr Common Layout script.
 *
 * This is loaded on every page, so all core registration is done here.
 */
(function($, L)
{

if (L === undefined)
{
  throw new Error("Missing Lum core");
}

var I = L.ns.add('iandr');     // The main namespace.
L.ns.export('iandr', 'IandR'); // Compatibility with old 'IandR' namespace.
L.ns.export('iandr', 'IANDR'); // And the all-caps version for good measure.

var Layout = I.Layout = {};

Layout.autoFocus = function ()
{
  var fieldnames = (arguments.length > 0) 
    ? Array.prototype.slice.call(arguments) 
    : ['#config_name', '#module_name', '#report_name'];
  for (var i = 0; i < fieldnames.length; i++)
  {
    var fname = fieldnames[i];
    var field = $(fname);
    if (field.length > 0)
    {
      field.focus();
      return true;
    }
  }
  // If we reached here, we didn't find any fields to focus.
  return false;
}

Layout.autoFocus.onLoad = true;

Layout.captureEnter = function (e)
{
  var key = e.which;
//  console.log("user is pressing key", key);
  if (key == 13)
  {
//    console.log("The user pressed Enter");
    e.preventDefault();
    e.stopPropagation();
    $(this).blur();
    if (e.data !== undefined && typeof e.data.callback === 'function')
    {
      e.data.callback.call(this, e);
    }
    return false;
  }
}

Layout.captureBacktick = function (e)
{
  if (e.data !== undefined && typeof e.data.callback === 'function')
  { // This requires a 'callback' data option.
    if (!e.shiftKey && e.which == 192)
    {
      e.preventDefault();
      e.stopPropagation();
      e.data.callback.call(this, e);
      return false;
    }
  }
}

Layout.captureEnter.registerDynamic = function (selector1, selector2, ev)
{
  if (selector1 === undefined)
    selector1 = 'body';
  if (selector2 === undefined)
    selector2 = 'input';
  if (ev === undefined)
    ev = 'keydown';

  $(selector1).on(ev, selector2, Layout.captureEnter);
}

Layout.captureEnter.registerStatic = function (selector, ev)
{
  if (selector === undefined)
    selector = 'input[type="text"],input[type="number"]';
  if (ev === undefined)
    ev = 'keydown';

  $(selector).on(ev, Layout.captureEnter);
}

Layout.toggleSearch = function (e)
{
  var lh;
  if (e.data !== undefined && e.data.listHeader !== undefined)
    lh = e.data.listHeader;
  else
    lh = $('.listing_headers');
  lh.toggleClass('showSearch');
  if (lh.hasClass('showSearch'))
  {
    lh.find('input.search').first().focus();
  }
}

// Override in your scripts to not automatically run staticInputs.
Layout.captureEnter.autoStatic = true;

// Override in your scripts if you want to automatically run dynamicInputs.
Layout.captureEnter.autoDynamic = false;

// Compatibility wrapper with old Alerts.
I.Alerts =
{
  getStatus: function (conf={})
  {
    if (this.statusObject === undefined)
    {
      if (conf.actionHandlers === undefined)
        conf.actionHandlers = {};
      let self = this; // A reference to the Alerts wrapper.
      conf.actionHandlers.dismiss = function (notObj)
      {
        if (notObj.opts.rowId)
        { // It has a row id, let's dismiss it via the API.
          self.dismissNotification(notObj.opts.rowId).done(function (data)
          {
            if (data.success)
            {
              notObj.remove(true);
            }
            else
            {
              console.debug("Attempt to dismiss notifiation failed with API error", arguments);
            }
          }).fail(function ()
          {
            console.debug("Attempt to dismiss notification failed with app error", arguments);
          });
        }
        else
        { // Remove it immediately.
          notObj.remove(true);
        }
      }
      this.statusObject = new L.Notifications(conf);
    }
    return this.statusObject;
  },
  dismissNotification: function (nid)
  {
    let url = $('#notification_api_url').val().replace('{nid}',nid);
    return $.ajax(url, {dataType: 'json', method: 'DELETE'});
  },
  editNotification: function (nid, data)
  {
    let url = $('#notification_api_url').val().replace('{nid}',nid);
    return $.ajax(url, 
    {
      dataType: 'json',
      method: 'PUT',
      data: JSON.stringify(data),
      contentType: 'application/json',
    });
  },
  createNotification: function (data)
  {
    let url = $('#notification_api_url').val().replace('/{nid}', '');
    return $.ajax(url, 
    {
      dataType: 'json', 
      method: 'POST', 
      data: JSON.stringify(data), 
      contentType: 'application/json'
    });
  },
  listNotifications: function (opts)
  {
    let url = $('#notification_api_url').val().replace('/{nid}', '');
    return $.ajax(url, {dataType: 'json', method: 'GET', data: opts});
  },
};

Layout.registerExpandButton = function ()
{
  var appMenu = $('#app_menu');
  var header = $('#header');
  var topMenu = $('#top_menu');
  var pageBody = $('#page_body');

  var expandButton = $('<span class="toggle" id="expand_focus_mode">&#x21d7;</span>');
  var collapseButton = $('<span class="toggle" id="collase_focus_mode">&#x21d9;</span>');

  function rememberExpanded (expanded)
  {
    if (window.sessionStorage)
    { // Only works if we have sessionStorage.
      if (typeof expanded === 'boolean')
      { // We're changing the value.
        sessionStorage.iandrPageExpanded = JSON.stringify(expanded);
      }
      else
      { // We're returning the value.
        expanded = sessionStorage.iandrPageExpanded;
        if (expanded === undefined)
        { // Not set yet, defaults to false.
          return false;
        }
        expanded = JSON.parse(expanded);
        return expanded;
      }
    }
    else
    { // No Storage support, we simply return false, the page is not expanded.
      return false;
    }
  }

  function addExpandButton ()
  {
    appMenu.append(expandButton);
  }

  function addCollapseButton ()
  {
    appMenu.append(collapseButton);
  }

  function expandPageBody ()
  {
    header.hide();
    topMenu.hide();
    pageBody.css('margin', '0px');
    expandButton.detach();
    addCollapseButton();
    rememberExpanded(true);
  }

  function collapsePageBody ()
  {
    header.show();
    topMenu.show();
    pageBody.css('margin', '');
    collapseButton.detach();
    addExpandButton();
    rememberExpanded(false);
  }

  expandButton.on('click', expandPageBody);
  collapseButton.on('click', collapsePageBody);

  if (rememberExpanded())
  { // Start with the page expanded.
    expandPageBody();
  }
  else
  { // Start with an expand button.
    addExpandButton();
  }
}

// The default tab selector for our TabPanes instance.
Layout.tabSelector = '#page_submenu .tabs a';

// The default pane selector for our TabPanes instance.
Layout.paneSelector = 'div.subpane';

// Register a TabPanes instance.
Layout.registerTabs = function (options={})
{
  if (!options.tabsSelector)
  {
    options.tabsSelector = this.tabSelector;
  }
  if (!options.paneSelector)
  {
    options.paneSelector = this.paneSelector;
  }

  this.tabPanes = new L.TabPanes(options);
}

$(function () {
  // Prevent users from pressing enter on text fields.  
  if (Layout.captureEnter.autoDynamic)
  {
    Layout.captureEnter.registerDynamic();
  }
  else if (Layout.captureEnter.autoStatic)
  {
    Layout.captureEnter.registerStatic();
  }

  // An additional check for Listing pages.
  if (iandr.Listing !== undefined)
  {
    $('body').on('keydown', 
      {callback: Layout.toggleSearch}, Layout.captureBacktick);
  }

  // Initialize the Notifications library.
  I.Alerts.getStatus();

  // Ensure that menu items with the 'disabled' class, are disabled.
  $('#app_menu a').click(function(e)
  {
    var link = $(this);
    if (link.hasClass('disabled'))
    {
      e.preventDefault();
      return false;
    }
    else
    {
      return true;
    }
  });

  if (!$('#menu_bar').exists())
  {
    Layout.registerExpandButton();
  }

  // The #toggle_search button if it exists needs to do stuff.
  $('#toggle_search').on('click', Layout.toggleSearch);

  if (Layout.autoFocus.onLoad)
  { // Call the autoFocus method with it's default options.
    Layout.autoFocus();
  }

});

})(window.jQuery, window.Lum);

